<script setup lang="ts">
import { MENU_LINKS } from '~/shared/lib/menu-links.const';

const columnsCount = ref(5);

const { breakpoint } = useViewport();

const emit = defineEmits(['closeMenu']);

watchEffect(() => {
  switch (breakpoint.value) {
    case 'xs':
      columnsCount.value = 2;
      break;
    case 'mobile':
    case 'mobileBig':
    case 'tablet':
      columnsCount.value = 3;
      break;
    case 'tabletBig':
      columnsCount.value = 4;
      break;
    case 'desktop':
      columnsCount.value = 5;
      break;
  }
});

const groupedLinks = computed(() => {
  const result = [];

  if (columnsCount.value === 2) {
    result.push([MENU_LINKS[4], MENU_LINKS[0], MENU_LINKS[2]]);
    result.push([MENU_LINKS[1], MENU_LINKS[3], MENU_LINKS[5]]);
  }
  if (columnsCount.value === 3) {
    result.push([MENU_LINKS[0], MENU_LINKS[3]]);
    result.push([MENU_LINKS[4], MENU_LINKS[1]]);
    result.push([MENU_LINKS[2], MENU_LINKS[5]]);
  }
  if (columnsCount.value === 4) {
    result.push([MENU_LINKS[4], MENU_LINKS[0]]);
    result.push([MENU_LINKS[1], MENU_LINKS[5]]);
    result.push([MENU_LINKS[2]]);
    result.push([MENU_LINKS[3]]);
  }
  if (columnsCount.value === 5) {
    result.push([MENU_LINKS[0]]);
    result.push([MENU_LINKS[1]]);
    result.push([MENU_LINKS[2]]);
    result.push([MENU_LINKS[3]]);
    result.push([MENU_LINKS[4], MENU_LINKS[5]]);
  }
  return result;
});
</script>

<template>
  <div :class="$style.menu__sitemap">
    <div
      v-for="(col, colIndex) in groupedLinks"
      :key="`groupedCol_${colIndex}`"
      :class="$style.menu__column"
    >
      <template v-for="(item, index) in col" :key="`menuLinks_${col}_${index}`">
        <MenuLinksItem
          v-if="item"
          :group="item"
          @close-menu="emit('closeMenu')"
        />
      </template>
    </div>
  </div>
</template>

<style module lang="scss">
.menu {
  &__sitemap {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;
    gap: var(--space-5x);
    flex-grow: 1;
  }

  &__column {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--space-4x);
    flex: 1;
  }
}

@media (max-width: 1379px) {
  .menu {
    &__sitemap {
      gap: 14px;
    }
  }
}
</style>
